module.exports = __webpack_public_path__ + "static/atlaskit-table-empty-message-9a8a135b3082bf9b96ff6d8aab6b652b.png";